var _desc, _value, _class, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { action, observable } from 'mobx';

import { publish, subscribe } from 'sdc-publish-subscribe';

import { languagesStore } from '../languages';

export var LabelsStore = (_class = function LabelsStore() {
  var _this = this;

  _classCallCheck(this, LabelsStore);

  this.translations = {};
  this.translations = {};

  _initDefineProp(this, 'lastUpdate', _descriptor, this);

  this.updateTranslations = function (translations) {
    _this.setTranslations(translations || {});
  };

  this.addTranslation = function (key, value) {
    _this.translations[key] = value;
    _this.publishUpdate();
  };

  this.setTranslations = function (translations) {
    _this.translations = translations;
    _this.publishUpdate();
  };

  _initDefineProp(this, 'publishUpdate', _descriptor2, this);

  this.labelFor = function (key) {
    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.textFrom(languagesStore.selectedLanguage, key, replacements);
  };

  this.textFrom = function (language, key) {
    var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var translation = _this.translationFor(language, key, replacements.count);
    if (translation === undefined && language !== languagesStore.defaultLanguage) {
      translation = _this.translationFor(languagesStore.defaultLanguage, key, replacements.count);
    }
    return _this.replace(translation, replacements) || key;
  };

  this.translationFor = function (language, path) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (_this.translations === undefined) return undefined;
    if (count !== null) {
      var num = path + '_' + count;
      if (_this.translations[num]) return _this.translations[num][language];
      if (count !== 1) {
        var pl = path + '_plural';
        if (_this.translations[pl]) return _this.translations[pl][language];
      }
    }
    return (_this.translations[path] || {})[language];
  };

  this.replace = function (text, replacements) {
    if (typeof text === 'string') {
      var result = text;
      Object.keys(replacements).forEach(function (token) {
        result = result.split('%{' + token + '}').join(replacements[token]);
      });
      return result;
    }
    return text;
  };

  subscribe('i18n.translations', this.updateTranslations);
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'lastUpdate', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return new Date().valueOf();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'publishUpdate', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      publish('sdc-i18n-renderAll');
      _this2.lastUpdate = new Date().valueOf();
    };
  }
})), _class);

export var labelsStore = new LabelsStore();